import { Outlet } from 'react-router-dom';
import { ThemeToggle } from '@/components/app/ThemeToggle';
import { Wordmark } from '@/components/app/Wordmark';

export function AuthLayout() {
  return (
    <div className="fw-hero-bg fw-grain relative flex min-h-screen flex-col">
      <header className="relative z-10 flex items-center justify-between px-6 py-5 md:px-10">
        <Wordmark />
        <ThemeToggle />
      </header>
      <main className="relative z-10 flex flex-1 items-center justify-center px-6 py-12">
        <Outlet />
      </main>
      {/* No tenant name here — this chrome renders for EVERY company's sign-in
          (the sandbox roster was footed "Airoldi Brothers pilot", and tenant 2
          would be too — elite-audit F18, 2026-08-26). */}
      <footer className="text-fw-text-muted relative z-10 px-6 py-6 text-center text-xs">
        <p>Fleetwise AI · built with Roldi · {new Date().getFullYear()}</p>
      </footer>
    </div>
  );
}
